React = require 'react'
{ UpgradePromptFullConnected: UpgradePromptFull } = require 'app/src/components/UpgradePrompts/UpgradePromptFull'
{ MoonshotPopoverConnected: MoonshotPopover } = require 'app/src/components/Moonshot/MoonshotPopover'
{ TeamTemplatePicker } = require 'app/src/components/TeamTemplatePicker'
{ IconName } = require 'app/common/components/controls'
t = require('app/scripts/views/internal/recup-with-helpers')('board_list')
_ = require 'underscore'
{ Noun, Verb, trackUe } = require '@trello/analytics'
{ dontUpsell } = require '@trello/config'
{ UnsplashTracker } = require '@trello/unsplash'
{ Campaigns } = require 'app/common/data/campaigns'
l = require 'app/scripts/lib/localize'
Board = require 'app/scripts/models/board'
ModelCache = require 'app/scripts/db/model-cache'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class extends React.Component
  displayName: 'BoardListSectionComponent'
  constructor: (props) ->
    super(props)

    @state = {
      collapsed: true
    }

  componentDidMount: ->
    @trackUnsplashViews()

  componentDidUpdate: (prevProps) ->
    if !_.isEqual(@props.items, prevProps.items)
      @trackUnsplashViews()

  trackUnsplashViews: ->
    { items } = @props
    backgrounds = @getDisplayableItems()

    backgroundImages = backgrounds.map((background) ->
      background.props.background.image
    )
    backgroundImagesFiltered = backgroundImages.filter (bg) -> !!bg
    if backgroundImagesFiltered.length
      UnsplashTracker.trackOncePerInterval(backgroundImagesFiltered)

  getDisplayableItems: ->
    { items, mayBeSorted } = @props
    { collapsed } = @state
    displayableItems =
      if mayBeSorted
        _.chain items
          .sortBy (item) -> -(item.props.dateLastActivity)
          .filter (item, index) -> !collapsed || index <= 10 ||  !item.props.isLessActive
          .sortBy (item) -> item.props.name.toLowerCase()
          .value()
      else
        items
    return displayableItems

  onTemplateCopied: (board) ->
    boardModel = new Board(board, { modelCache: ModelCache })
    org = ModelCache.get('Organization', @props.orgId)
    org.boardList.add(boardModel)

  render: t.renderable ->
    { items,
      header,
      noSidebarMod,
      createNewItem,
      mayBeSorted,
      showAd,
      privateBoardTiles,
      topBanner,
      bottomBanner,
      canShowWelcomePopover,
      canShowTeamTemplatePicker,
      orgId } = @props
    boardCount = items.length
    displayedItems = @getDisplayableItems()

    lessActiveCount = boardCount - displayedItems.length

    classes = t.classify
      'boards-page-board-section': !showAd
      'mod-no-sidebar': noSidebarMod

    t.div { class: classes }, =>
      if header
        t.addElement header

      if topBanner
        t.div '.boards-page-top-banner', =>
          t.addElement topBanner

      if canShowWelcomePopover
        t.div '.boards-page-moonshot-popover', =>
          t.addElement(React.createElement(MoonshotPopover, { orgId }))

      if showAd && !dontUpsell
        t.div '.boards-page-layout', =>
          t.div '.boards-page-layout-sidebar', =>
            t.div '.boards-page-ad-section', =>
              t.addElement @orgAdComponent()
          t.div '.boards-page-layout-list', =>
            if canShowTeamTemplatePicker
              t.addElement(React.createElement(TeamTemplatePicker, { orgId, onTemplateCopied: (board) => @onTemplateCopied(board) }))
            t.ul '.boards-page-board-section-list', =>
              for item in displayedItems
                t.addElement item
              if privateBoardTiles
                t.addElement privateBoardTiles
              if createNewItem
                t.addElement createNewItem
      else
        t.div =>
          if canShowTeamTemplatePicker
            t.addElement(React.createElement(TeamTemplatePicker, { orgId, onTemplateCopied: (board) => @onTemplateCopied(board) }))
          t.ul '.boards-page-board-section-list', ->
            for item in displayedItems
              t.addElement item
            if privateBoardTiles
              t.addElement privateBoardTiles
            if createNewItem
              t.addElement createNewItem

      if bottomBanner
         t.div '.boards-page-bottom-banner', =>
            t.addElement bottomBanner

      onShowAllClick = =>
        @setState(collapsed: false)

      if displayedItems.length < items.length
        t.b onShowAllClick, '.boards-page-show-all-boards.quiet-button',  ->
          t.format 'show-less-active-boards-count', { lessActiveCount }


  orgAdComponent: =>
    props =
      content: l(['upgrade prompt', 'team page', 'boards', 'content-2'])
      headline: l(['upgrade prompt', 'team page', 'boards', 'headline-2'])
      cta: l(['upgrade prompt', 'learn more'])
      ctaLink: @props.billingUrl
      orgId: @props.orgId
      source: 'teamScreen'
      ctaOnClick: => trackUe({
        category: Noun.TEAM_PAGE,
        verb: Verb.OPENS,
        directObj: Noun.BC_MODAL,
        method: 'by clicking full upgrade prompt in team page board tab'
      })
      iconName: IconName.Board
      isDarkTheme: true

    React.createElement UpgradePromptFull, props
